
























































import { Action, RootAction } from '@/features/core/store';
import { AddToastMessageParams } from '@/features/core/store/toast';
import { EditFormInput } from '@/types/iot-portal';
import { StringProp } from '@/util/prop-decorators';
import { Component, Vue } from 'vue-property-decorator';
import editFormMutation from './edit-form.gql';
import query from './view.gql';
import permittedUserQuery from './permittedUsers.gql';
import {
  AppCustomerFormViewEditForm,
  AppCustomerFormViewEditFormVariables,
} from './__generated__/AppCustomerFormViewEditForm';
import { AppCustomerFormViewQuery, AppCustomerFormViewQueryVariables } from './__generated__/AppCustomerFormViewQuery';
import { pluckIds } from '@/util/pluck-id';
import { CUSTOMER_ADMIN_ROLE } from '@/features/core/store/const';
import { CustomerAdminQuery, CustomerAdminQueryVariables } from './__generated__/CustomerAdminQuery';
import { ApolloQueryResult } from 'apollo-client';
import { CustomerAdminRow, FormAttributeDefinition } from './model';
import { omitDeepBy } from '@/util/omit-deep-by';

type Form = AppCustomerFormViewQuery['customers']['first']['forms']['first'];

@Component({
  apollo: {
    customers: {
      query,
      variables(this: FormView): AppCustomerFormViewQueryVariables {
        return { customerId: this.customerId, formId: this.formId };
      },
    },
    treeNodes: {
      query: permittedUserQuery,
      variables(this: FormView): CustomerAdminQueryVariables {
        return { treeNodeId: this.customerId, userRole: CUSTOMER_ADMIN_ROLE };
      },
      result(this: FormView, { data }: ApolloQueryResult<CustomerAdminQuery>): void {
        this.permittedUsers = data.treeNodes?.first.permittedUsers || [];
      },
    },
  },
  data() {
    return {
      forms: undefined,
      permittedUsers: undefined,
      pluckIds,
    };
  },
})
export default class FormView extends Vue {
  @StringProp(true)
  private readonly customerId!: string;

  @StringProp(true)
  private readonly formId!: string;

  @RootAction
  private readonly ADD_TOAST_MESSAGES!: Action<AddToastMessageParams, void>;

  private readonly customers?: AppCustomerFormViewQuery['customers'];

  private permittedUsers?: CustomerAdminQuery['treeNodes']['first']['permittedUsers'];

  private get permittedUsersList(): CustomerAdminRow[] | [] {
    return this.permittedUsers || [];
  }

  private get form(): Form | undefined {
    return this.customers?.first.forms.first;
  }

  private get loadingPermittedUsers(): boolean {
    return this.$apollo.queries.treeNodes.loading;
  }

  private async editForm(input: Omit<EditFormInput, 'id'>): Promise<void> {
    const { data } = await this.$apollo.mutate<AppCustomerFormViewEditForm, AppCustomerFormViewEditFormVariables>({
      mutation: editFormMutation,
      variables: {
        input: {
          attributeDefinitionIds: null,
          id: this.formId,
          ...input,
        },
      },
    });

    if (!data) {
      throw new Error('Das Formular konnte nicht gespeichert werden.');
    }

    this.ADD_TOAST_MESSAGES({
      messages: [{ text: 'Formular gespeichert!', class: 'success' }],
    });
  }

  private format(value: FormAttributeDefinition[]): any {
    return omitDeepBy(value, (value, key) => key === '__typename' || key === 'attributeDefinition') || [];
  }
}
